import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=459c2fe4&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('459c2fe4')) {
      api.createRecord('459c2fe4', component.options)
    } else {
      api.reload('459c2fe4', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=459c2fe4&", function () {
      api.rerender('459c2fe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Chart/Text.vue"
export default component.exports